import React from 'react';

//Componentes auxiliares:
import RadioButton from './RadioButton';

//Scripts auxiliares:
import { getSourceTitleText, getSourceSubtitleText } from '../../../views/common/downloadSourcesRenderingFunctions';

let SourceSelector = (props) => {
    return (
        <div style={{ flexDirection: "column", width: "100%", paddingTop: 15, paddingRight: "10%" }}>
            <h6 className="card-title noselect" style={{ cursor: "pointer", marginBottom: 0, marginTop: 0 }}>
                <p style={{ fontSize: 10, marginBottom: 0 }}>
                    {(props.title || "Fuente en edición") + ":"}</p>
            </h6>

            <div style={{ paddingLeft: "5%", paddingTop: 20 }}>
                {props.downloadSources.map((downloadSource, i) => {
                    return (
                        <RadioButton
                            downloadSource={downloadSource}
                            label={getFormattedSourceLabel(downloadSource.description)}
                            key={"downloadSourceSelector." + i + "." + (new Date()).getTime()}
                            checked={(downloadSource.id === props.activeDownloadSource.id)}
                            onClick={(newDownloadSource) => {
                                props.setNewActiveDownloadSource(newDownloadSource);
                            }} />
                    );
                })}
            </div>
        </div>
    );
}

let getFormattedSourceLabel = (description) => {
    return "<b>" + getSourceTitleText(description) + "</b>" + getSourceSubtitleText(description);
}

export default SourceSelector;